export enum SubsidizedEnum {
	NOT_REQUIRED = 'Not required',
	YES = 'yes',
	NO = 'no',
}
